module.exports = require('./helpers/bundle-url').getBundleURL('ex1cr') + "../images/chevron-down.76cbd0c4.svg";